import {
  __name
} from "../../chunk-7QVYU63E.js";
import { scrubSensitiveHeaders } from "#axios/interceptors.js";
import axios, { AxiosError, isAxiosError } from "axios";
function createBrowserAxiosInstance(config) {
  const instance = axios.create(config);
  instance.interceptors.response.use(void 0, scrubSensitiveHeaders);
  return instance;
}
__name(createBrowserAxiosInstance, "createBrowserAxiosInstance");
export {
  AxiosError,
  createBrowserAxiosInstance,
  isAxiosError
};
//# sourceMappingURL=browserAxios.js.map